<template>
  <v-sheet elevation="0" width="100%" class="pa-3" style="margin-bottom: 1px; background-color: #CFD8DC;">
    <v-row style="padding-left:10px;" >
      <v-overlay :value="overlay">
        <v-img
          :src="getImage()"
          opacity="0.96"
          @click="onScreenShotClicked"
        >
        </v-img>
      </v-overlay>

      <v-img
        :src="getThumbnail()"
        aspect-ratio="1"
        max-width="96"
        max-height="54"
        @click="onScreenShotClicked"
      >
      </v-img>
      <div style="padding-left:5px;">Created At: <b>{{formatTime(createdAt)}}</b></div>
      <v-spacer></v-spacer>
      <v-btn style="margin-right:10px;top:8px;" @click="onDownloadImg">Download</v-btn>
      <v-btn style="margin-right:10px;top:8px;" @click="onDeleteClicked">Delete</v-btn>
    </v-row>
  </v-sheet>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    id: String,
    image: String,
    thumbnail: String,
    createdAt: String,
  },

  data() {
    return {
      overlay: false,
    };
  },

  methods: {
    formatTime(time) {
      return moment(time).local().format('YYYY-MM-DD HH:mm:ss');
    },

    getImage() {
      console.log(`---- image is ${this.image}`);
      return this.image;
    },

    getThumbnail() {
      console.log(`---- thumbnail is ${this.thumbnail}`);
      return this.thumbnail;
    },

    onScreenShotClicked() {
      console.log('screen shot clicked...');
      this.overlay = !this.overlay;
    },

    onDeleteClicked() {
      console.log('delete was clicked...');
      this.$emit('onDelete', this.id);
    },

    onDownloadImg() {
      console.log(`image: ${this.image}`);
      console.log(`thumbnail: ${this.thumbnail}`);

      this.$http({
        method: 'get',
        url: this.getImage(),
        responseType: 'arraybuffer',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        const fileName = this.getImage().replace(/^.*[\\\/]/, '');

        console.log(`filename will be: ${fileName}`);

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      });
    },
  },
};
</script>
